import {get, post} from './http'

// 登录
export const login = data => post('/user/login', data)

// 用户退出
export const logout = data => post('/user/logout', data)

// 获取用户信息
export const getUserInfo = data => get('/user/getCurrentUser', data)

// 获取媒体墙节目列表
export const getMediaWallProgram = data => post('/program/pageProgramMediaWallList', data)

// 查询媒体墙列表
export const getMediaWallList = data => post('/lightNode/mediawall/pageMediaWallNodeList', data)

// 批量修改媒体墙节目是否大屏展示状态
export const batchUpdateMedialWallShowStatus = data => post('/program/batchSetProgramBigScreenPlay', data)

// 播放节目
export const playMediaWallProgram = data => post('/program/playProgram', data)

// 获取监控列表
export const getMonitorList = data => post('/monitor/pageQueryMointorList', data)

// 查询楼宇
export const getBuildingList = data => post('/build/pageBuildList', data)

export const getOnlineRate = data => post('/statistic/mediawall/onlineStatistics', data)

// 获取回路管理列表
export const getSwitchLoopList = data => get('/equipment/management/getSwitchInfo', data)

// 开关控制
export const ctrlSwitch = data => post('/equipment/management/ctrlSwitch', data)

// 开关分组
export const getSwitchGroupList = data => get('/area/management/getSwitchGroup', data)

// 分组开关状态控制
export const updateSwitchStatus = data => post('/area/management/updateSwitchStatus', data)

// 分组定时任务状态控制
export const updateRegionTaskStatus = data => post('/area/management/updateTaskStatus', data)

// 获取配电柜区域分布
export const getDeviceBlock = data => get('/area/management/getAreaDistribution', data)

// 报警管理
export const getWarningList = data => get('/alarm/management/getAlarmInfo', data)

// 能耗统计
export const getEnergyStatistics = data => get('/meter/management/getTotalEnergy', data)

// 区域能耗
export const getAreaStatistics = data => get('meter/management/getAreaEnergy', data)

// 查询所有类型节点位置信息
export const getNodePositionList = data => post('/statistic/map/location', data)

// 获取配电柜在线率
export const getDeviceOnlineRate = data => get('/equipment/management/getStationOnlineRate', data)